import axios from "../../../../api/axios";

import { Comment } from "../../types/comment.type";
import { User } from "../../../../types/types";

export interface CommentResponse {
  items: Comment[];
  total: number;
  message: string;
  mentionedUsers: Partial<User>[];
}

export const getComments = async (limit: number, postId: number, offset?: number) => {
  const response = await axios.get<{ data: CommentResponse }>(
    `/comments?limit=${limit}&postId=${postId}${offset ? `&offset=${offset}` : ""}`
  );
  return response.data.data;
};

export const likeComment = async (commentId: number) => {
  const response = await axios.get(`/v1/comments/${commentId}/like`);
  return response.data;
};

export const unlikeComment = async (commentId: number) => {
  const response = await axios.delete(`/v1/comments/${commentId}/like`);
  return response.data;
};
